import { render, staticRenderFns } from "./Icon-hifos-component.vue?vue&type=template&id=8c8dcdf4"
import script from "./Icon-hifos-component.vue?vue&type=script&lang=js"
export * from "./Icon-hifos-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports